import qiunVueUcharts from './qiun-vue-ucharts.vue'
export default qiunVueUcharts;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@qiun/vue-ucharts/src/index.js
// module id = +zCz
// module chunks = 100